export const PATH_TYPE_COPY = '0X2221'


// 结算方式
export const settTypeList = [{
    "code": "1",
    "name": "票扣"
}, {
    "code": "2",
    "name": "账扣"
}, {
    "code": "3",
    "name": "实物"
}]

// 进场性质
export const enterList = [{
    "code": "1",
    "name": "全新超市/卖场"
}, {
    "code": "2",
    "name": "现有超市新门店"
}, {
    "code": "3",
    "name": "现有超市添加品种"
}, {
    "code": "4",
    "name": "其他"
}]
export const enterType = {
    all: '1',
    now: '2',
    add: '3',
    other: '4'
}

// 审核状态
export const auditList = [{
    "code": "0",
    "name": "待提交"
}, {
    "code": "1",
    "name": "审批中"
}, {
    "code": "2",
    "name": "已审核"
}, {
    "code": "3",
    "name": "已驳回"
}]

export const auditStatusList = {
    "0": "待提交",
    "1": "审批中",
    "2": "已审核",
    "3": "已驳回"
}

export const xlsApiList = {
    'entryAppliInfo': 'SuperApply/excelExport',
    'salesAppliInfo': 'SalesPromo/excelExport',
    'applyAccountInfo': 'ExpenseReport/excelExport',
    'entrySettlement': "SuperApplySett/excelExport",
    'salesSettlement': "SalesSett/excelExport",
    'SalesSettZ': "SalesSettZ/excelExport",
    'SuperApplySettZ': "SuperApplySettZ/excelExport",
}

export const entryFileList = [{
    "title": "协议",
    "code": "protocol"
}, {
    "title": "送货回单",
    "code": "deliver"
}, {
    "title": "付费凭证",
    "code": "pay"
}, {
    "title": "门店地址",
    "code": "address"
}, {
    "title": "合同原件",
    "code": "hetong"
}]

export const salesFileList = [{
    "title": "协议",
    "code": "protocol"
}, {
    "title": "送货回单",
    "code": "deliver"
}, {
    "title": "付费凭证",
    "code": "pay"
}, {
    "title": "特价照片",
    "code": "photo"
}, {
    "title": "促销评估",
    "code": "evalute"
}, {
    "title": "DM",
    "code": "pm"
}, {
    "title": "TG",
    "code": "tg"
}]

export const costAnalysisQueryType = {
    area:{
        label:'业务员',
        value:'A'
    },
    salesman:{
        label:'部门',
        value:'Y'
    }
}